import Typography from '@alltrails/core/components/Typography';
import { FormattedMessage } from 'react-intl';
import getHelpCenterUrl from '@alltrails/shared/utils/constants/helpCenterUrl';
import { useLanguageRegionCode } from '@alltrails/language/hooks/useLanguageRegionCode';
import Link from '@alltrails/denali/components/Link';
import styles from './HeatmapPrivacyModal.module.scss';

const HeatmapPrivacyModalContent = () => {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <div>
      <Typography variant="text200" className={styles.heatmapPrivacyModalText} component="div">
        <FormattedMessage
          defaultMessage="The community heatmap shows public trail activity from the AllTrails community, including AllTrails activities recorded on wearables like Garmin, Apple Watch, or Android devices. If you’d like to opt out, you can <a>adjust the privacy settings for your activities</a>."
          values={{
            a: chunks => (
              <Link href={getHelpCenterUrl(languageRegionCode, 4410205748244)} target="_blank">
                {chunks}
              </Link>
            )
          }}
        />
      </Typography>
      <Typography variant="text200" component="div">
        <br />
      </Typography>
      <Typography variant="text200" component="div">
        <FormattedMessage defaultMessage="When using heatmaps to explore new routes, be sure to follow posted signs and respect private property, culturally sensitive areas, and local regulations." />
      </Typography>
    </div>
  );
};

export default HeatmapPrivacyModalContent;
